export function makeFormatters(now: Date) {
  const rel = (iso: string) => {
    const t = new Date(iso);
    const diff = (now.getTime() - t.getTime()) / 1000;
    if (diff < 60) return `${Math.floor(diff)}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86_400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86_400)}d ago`;
  };

  const duration = (startIso: string, endIso?: string | null) => {
    const a = new Date(startIso);
    const b = endIso ? new Date(endIso) : now;
    const mins = Math.floor((b.getTime() - a.getTime()) / 60_000);
    if (mins < 60) return `${mins}m`;
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    if (h < 24) return m ? `${h}h ${m}m` : `${h}h`;
    const d = Math.floor(h / 24);
    return `${d}d ${h % 24}h`;
  };

  const time = (iso: string) => {
    const d = new Date(iso);
    return (
      d.toLocaleTimeString("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "UTC",
      }) + " UTC"
    );
  };

  const datetime = (iso: string) => {
    const d = new Date(iso);
    return (
      d.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        timeZone: "UTC",
      }) +
      " · " +
      time(iso)
    );
  };

  return { rel, duration, time, datetime };
}

export type Formatters = ReturnType<typeof makeFormatters>;

export const STATE_META: Record<
  string,
  { label: string; tone: "success" | "warning" | "destructive" | "info" }
> = {
  operational: { label: "Operational", tone: "success" },
  degraded: { label: "Degraded", tone: "warning" },
  "major-outage": { label: "Major outage", tone: "destructive" },
  maintenance: { label: "Maintenance", tone: "info" },
  minor: { label: "Minor", tone: "warning" },
  major: { label: "Major", tone: "destructive" },
};

export const SEVERITY_COLOR: Record<string, string> = {
  major: "var(--destructive)",
  "major-outage": "var(--destructive)",
  degraded: "var(--warning)",
  minor: "var(--warning)",
  maintenance: "var(--info)",
  operational: "var(--success)",
};
